export default "__VITE_ASSET__C8jkvCOb__"